import { get } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface WorkspaceBranding {
  slug: string | null;
  displayName: string | null;
  primaryHsl: string | null;
  secondaryHsl: string | null;
  accentHsl: string | null;
  brandHsl: string | null;
  logoLightS3Key: string | null;
  logoDarkS3Key: string | null;
  faviconS3Key: string | null;
}

export interface MyWorkspace {
  isWorkspace: boolean;
  branding: WorkspaceBranding | null;
}

// Public, pre-login: branding for a workspace slug (app.queri.law/<slug>).
export const getWorkspaceBranding = (
  slug: string
): Promise<ApiResponse<WorkspaceBranding>> => {
  return get(`/workspaces/${slug}/branding`, null);
};

// The authenticated caller's own workspace (branding), if any.
export const getMyWorkspace = (): Promise<ApiResponse<MyWorkspace>> => {
  return get(`/workspaces/me`, null);
};

// A weighted-random greeting template for the caller's workspace.
export const getMyGreeting = (): Promise<ApiResponse<{ template: string | null }>> => {
  return get(`/workspaces/me/greeting`, null);
};
